import { createClient } from "../../utils/supbase/client";


export const baseQuery = (table, select_query) => async ({
  type,
  data: body,
  id,
  filters,
  is,
  order,
  in: inFilter,
  gte,
  lte,
  limit,
  offset,
  multiFilters
}) => {
  const supabase = createClient();
  try {
    let query = supabase
      .from(table)
      .select(`*${select_query ? `, ${select_query}` : ''}`);
    
    if (filters) {
      for (const key in filters) {
        query = query.eq(key, filters[key]);
      }
    }
    
    if (multiFilters) {
      multiFilters.forEach(({ key, value }) => {
        query = query.eq(key, value);
      });
    }
    
    if (is) {
      for (const key in is) {
        query = query.is(key, is[key]);
      }
    }
    
    if (inFilter) {
      for (const key in inFilter) {
        query = query.in(key, inFilter[key]);
      }
    }
    
    if (order) {
      order.forEach(({ column, ascending }) => {
        query = query.order(column, { ascending });
      });
    } else {
      query = query.order('created_at', { ascending: false });
    }
    
    if (gte) {
      for (const key in gte) {
        query = query.gte(key, gte[key]);
      }
    }
    
    if (lte) {
      for (const key in lte) {
        query = query.lte(key, lte[key]);
      }
    }
    
    if (typeof offset === 'number' && typeof limit === 'number') {
      query = query.range(offset, offset + limit - 1);
    }

    let response;
    let data = null;
    
    switch (type) {
      case 'GET':
        response = await query;
        break;
      case 'GET_BY_ID':
        response = await supabase
          .from(table)
          .select(`*${select_query ? `, ${select_query}` : ''}`)
          .eq('id', id)
          .single();
        break;
      case 'POST':
        response = await supabase.from(table).insert([body]).select();
        break;
      case 'POST_MULTIPLE':
        response = await supabase.from(table).insert(body).select();
        break;
      case 'UPDATE_MULTIPLE':
        response = await supabase.from(table).upsert(body).select();
        break;
      case 'PATCH':
        response = await supabase.from(table).update(body).match({ id });
        break;
      case 'DELETE':
        response = await supabase.from(table).delete().match({ id });
        break;
      case 'SOFT_DELETE':
        response = await supabase.from(table).update({ is_deleted: true }).match({ id });
        break;
      default:
        throw new Error('Invalid type');
    }

    if (response.error) throw new Error(response.error.message);

    return { data: data !== null ? data : response.data };
  } catch (error) {
    console.error('Supabase Query Failed:', error?.message);
    throw error;
  }
};
